import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPolicyViolations = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M10 17a7 7 0 1 0 0-14 7 7 0 0 0 0 14M7.03 5.97a.75.75 0 0 0-1.06 1.06l7.016 7.016a.75.75 0 1 0 1.06-1.06z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPolicyViolations;
